var SCM = SCM || {};

(function (ns, $) {
    
    ns.initRegister = function (lastError) {
        const $formContainer = $('.widget-Register');
        const $form = $formContainer.find('.js-register-form');

        if (lastError != null && lastError.length > 0) {
            $formContainer.find('.error-message').html(lastError).show();
            $.post('/OUPMyAccount/ClearLastErrorMessage');
        }
        
        $form.on('submit', function(e) {
            submitForm(e);
        });

        SCM.TestPassword.initTestPassword('#Password', '#ConfirmPassword', '#registerBtn');
    };

    function submitForm(e) {
        e.preventDefault();
        const $formContainer = $('.widget-Register');
        clearErrors($formContainer);
        const $registerButton = $('#registerBtn');
        $registerButton.addClass('disabled');

        const email = $formContainer.find('#EmailAddress').val();
        const fullName = $formContainer.find('#FullName').val();
        const country = $formContainer.find('#CountryList').val();
        const password = $formContainer.find('#Password').val();
        const confirmPassword = $formContainer.find('#ConfirmPassword').val();
        
        const honeypotValue = $formContainer.find('#hpcName').val();
        const registerIssueAlert = $formContainer.find('#registerIssueAlert');
        const simpleCaptchaEnabled = $('.js-captcha-simple').length;
        const normalCaptchaEnabled = $('.js-captcha-normal').length;
        const txtCaptchaInputId = $('.js-captcha-input').val();
        let alertChecked = false;
        if (registerIssueAlert !== undefined) {
            alertChecked = !!registerIssueAlert.is(':checked');
        }
        const hfAlertJournalId = $formContainer.find('#hfAlertJournalId');
        const alertJournalId = hfAlertJournalId !== undefined && hfAlertJournalId.length > 0 ? hfAlertJournalId.val() : 0;
        const hfAlertSiteId = $formContainer.find('#hfAlertSiteId');
        const alertSiteId = hfAlertSiteId !== undefined && hfAlertSiteId.length > 0 ? hfAlertSiteId.val() : 0;

        if (honeypotValue.length > 0) {
            console.log('Honeypot captcha triggered. Are you a bot?');
            $registerButton.removeClass('disabled');
        } else {
            $.post('/OUPMyAccount/Register',
                {
                    email: email,
                    fullName: fullName,
                    country: country,
                    password: password,
                    confirmPassword: confirmPassword,
                    alertSiteId: alertChecked ? alertSiteId : 0,
                    alertJournalId: alertChecked ? alertJournalId : 0,
                    captchaResponse: normalCaptchaEnabled ? grecaptcha.getResponse() : '',
                    simpleCaptchaResponse: simpleCaptchaEnabled ? txtCaptchaInputId : ''
                },
                function (result) {
                    handleRegisterResponse(result, $registerButton);
                });
        }
    }

    function handleRegisterResponse(result, $registerButton) {
        if (result.ReturnId === 'captcha') {
            if ($('.js-captcha-normal').length) {
                $registerButton.removeClass('disabled');
                $('.js-captcha-error').removeClass('hidden');
            }
            else {
                window.location.reload();
            }
        }
        else if (result.ReturnId === 'OK') {
            window.location = getSignInUrl();
        } 
        else {
            $('.js-captcha-error').addClass('hidden');
            SCM.Captcha.ResetCaptcha($('.js-register-form'));

            $registerButton.removeClass('disabled');
            if (result.Messages.length) {
                showRegisterErrors(result.Messages);
            }
        }
    }

    function showRegisterErrors(messages) {
        var title = $(document).prop('title'); 
        $(document).prop('title', 'Error: ' + title);
        $('.register-error-message').show();
        $.each(messages, function(idx, value) {
            var $error = $('#' + value);
            $error.show();
            var $errorInput = $error.next();
            $errorInput.addClass('register-error-border');
            $errorInput.attr('aria-describedby', value);
            if (idx === 0) {
                $errorInput.focus();
            }
        });
    }

    function clearErrors($formContainer) {
        var title = $(document).prop('title'); 
        $(document).prop('title', title.replaceAll('Error: ', ''));
        $formContainer.find('.register-error-message').hide();
        $('.register-input').removeAttr('aria-describedby');
        $('.register-input').removeClass('register-error-border');
        $('.input-error').hide();
    }

    function getSignInUrl() {
        // Formerly named 'updateRedirectUri'
        // doing for proxy urls
        const sigmaSigninUrl = $('#sigmaSigninUrl').val();
        const redirectSiteUrl = $('#RedirectSiteUrl').val();
        const decodedUrl = SCM.ZEncoderV1.Decode(redirectSiteUrl);
        const params = sigmaSigninUrl.split('&');
        $.each(params, function (idx, val) {
            // only change the redirect uri parameter of the href
            if (val.startsWith('redirect_uri')) {
                const queryString = val.split('?');
                params[idx] = 'redirect_uri=' + decodedUrl + '/HTTPHandlers/Sigma/LoginHandler.ashx';
                if (queryString.length > 1) {
                    params[idx] += '?' + queryString[1];
                }
            }
        });
        return params.join('&');
    }

})(SCM.MyAccount = SCM.MyAccount || {}, jQuery);

$(function () {
    SCM.MyAccount.initRegister($('#lastErrorMessage').val());
});